import * as React from 'react';

export const NewLineText = (text: string, spliter: string) => {
    if (!text || !spliter) return null;

    // Split the string by the newline character to get an array of lines
    const lines = text.split(spliter);
    console.log(lines);

    // Map over the array to render each line followed by a <br />
    return (
        <>
            {lines.map((line, index) => (
                <span key={index}>
                    {line}
                    {/* Add <br /> for all lines except the last one */}
                    {index < lines.length - 1 && <br />}
                </span>
            ))}
        </>
    );
};